import { FC } from 'react'
import formatTime from '../util/formatTime'
import StatRow from './StatRow'
import useStats from '../hooks/useStats'

const PostGameStats: FC = () => {
	const stats = useStats()

	return (
		<div className="post-game-stats">
			<h2>Statistics</h2>
			<div className="post-game-stats-table">
				<StatRow label="Current streak" value={stats?.sk || 0} />
				<StatRow label="Played" value={stats?.p || 0} />
				<StatRow label="Best streak" value={stats?.b || 0} />
				{stats?.bt ? (
					<StatRow label="Best time" value={formatTime(stats?.bt || 0)} />
				) : null}
			</div>
		</div>
	)
}

export default PostGameStats
